module.exports = __webpack_public_path__ + "static/media/spin_iphone.c0131b0a.png";